import { Toast } from 'vant'
import { t } from '@/i18n'
import Analytics from '@/core/Analytics'

export default {
  beforeLoad: [
    async (app: any) => {
      Toast.loading({
        message: t('loading') as string,
        forbidClick: true,
        duration: 10000,
      })
    },
    async () => {
      Analytics.trackCoreScene('pg_core_mfe_main_end')
      Analytics.performanceMonitor.startTimeSliceTrack('pg_core_duration_mfe_mounted')
    },
  ],

  beforeMount: [
    async (app: any) => {
      Toast.clear()
    },
  ],

  afterMount: [
    async (app: any) => {
      const name = app.name.split('__')[1] || app.name
      Analytics.performanceMonitor.endTimeSliceTrack('pg_core_duration_mfe_mounted', name)
    },
  ],

  beforeUnmount: [async (app: any) => {}],

  afterUnmount: [],
}
